module.exports = __webpack_public_path__ + "f03e0deb5d9008cb6669e09f48389641.png";